import './general_attachment_view.js.coffee'

Customer.Conversation ||= {}
Customer.Conversation.Attachments ||= {}

class Customer.Conversation.Attachments.TwitterAttachmentsView extends Customer.Conversation.Attachments.GeneralAttachmentsView
  template: JST['backbone/templates/customer/conversation/attachments/twitter_attachments']

  onSelectImage: (evt) ->
    super(evt)
    @canAddImages = @imageFiles.length < @options.attachmentLimit
